import React from 'react';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Link from 'next/link';
import { URLS } from 'layouts/DrawerLayout/constants';
import { IconButtonV2 } from 'components/common/ui';
import { SUBSCRIPTIONS_STATUSES } from '@constants';
import { formatDate } from '@utils';
import {
  getHumanReadableDuration,
  getSubscriptionStatusColor,
} from 'helpers/sidebarGenericTicket';
import styles from './selectedSubscription.style';

const SelectedSubscription = ({ subscription = {}, onClose }) => {
  const statusText = SUBSCRIPTIONS_STATUSES[subscription.status] || '-';
  const statusColor = getSubscriptionStatusColor(subscription.status);

  const vehicleBrand = subscription.vehicle?.manufacturer || '';
  const vehicleModel = subscription.vehicle?.model || '';
  const vehicleName = `${vehicleBrand} ${vehicleModel}`.trim() || '-';

  const vehiclePlate =
    subscription.vehiclePlate || subscription.vehicle?.plate || '-';
  const createdAt = subscription.createdAt
    ? formatDate(subscription.createdAt, 'dd-MM-yyyy')
    : '-';

  const estimatedDuration =
    subscription.rules?.[subscription.rules.length - 1]?.estimatedDuration;
  const subscriptionPlan = getHumanReadableDuration(estimatedDuration);

  return (
    <>
      <Box sx={styles.title}>Subscription</Box>
      <Box sx={styles.wrapper}>
        <Box sx={styles.column}>
          <Box sx={styles.headerRow}>
            <Box sx={styles.vehicleName}>{vehicleName}</Box>
            <Box
              sx={{
                ...styles.statusBadge(statusColor),
              }}
            >
              <Box sx={styles.statusDot(statusColor)} />
              {statusText}
            </Box>
          </Box>
          <Box sx={styles.row}>
            {subscription.id ? (
              <Link href={`${URLS.subscriptions}/${subscription.id}`}>
                {subscription.id}
              </Link>
            ) : (
              <span>-</span>
            )}
          </Box>
          <Box sx={styles.detailsRow}>
            <Box>Created at: {createdAt}</Box>
            <Box>{vehiclePlate}</Box>
            <Box>{subscriptionPlan}</Box>
          </Box>
        </Box>
        <Box sx={styles.closeButton}>
          <IconButtonV2 variant="text" color="error" onClick={onClose}>
            <CloseIcon />
          </IconButtonV2>
        </Box>
      </Box>
    </>
  );
};

export default SelectedSubscription;
